export default {
  analyticsData: {},
  analyticsChart: {},
  analyticsPeriod: null,
  analyticsFirstColumn: null,
  analyticsTerritoryType: null,
  // TODO: get column types and their subtypes from api
  analyticsColumnTypes: [
    {id: 'mass', name: 'Масса'},
    {id: 'volume', name: 'Объем'},
    {id: 'power', name: 'Мощность'},
    {id: 'capacity_rest', name: 'Остаточная вместимость'},
    {id: 'mileage', name: 'Пробег ТС'},
    {id: 'removal_cost', name: 'Стоимость вывоза'},
    {id: 'transfer_cost', name: 'Стоимость перевозки'},
    {id: 'transportation_cost', name: 'Стоимость транспортирования'},
    {id: 'processing_cost', name: 'Стоимость обработки'},
    {id: 'total_cost', name: 'Полная стоимость'}
  ],
  analyticsColumnSubTypes: null,
  /* analyticsColumnSubTypes: {
    mass: [
      {id: 1, name: 'общая' },
      {id: 2, name: 'Жилье' },
      {id: 3, name: 'ЮЛ' },
      {id: 4, name: 'Соц. сфера' },
      {id: 5, name: 'Города' },
      {id: 6, name: 'Малые нас. пункты' },
      {id: 7, name: 'Контейнеры' },
      {id: 8, name: 'Бункеры' },
      {id: 9, name: 'Пакетный сбор' },
    ],
    volume: [
      {id: 1, name: 'общий' },
      {id: 2, name: 'Жилье' },
      {id: 3, name: 'ЮЛ' },
      {id: 4, name: 'Соц. сфера' },
      {id: 5, name: 'Города' },
      {id: 6, name: 'Малые нас. пункты' },
      {id: 7, name: 'Контейнеры' },
      {id: 8, name: 'Бункеры' },
      {id: 9, name: 'Пакетный сбор' },
    ],
    power: [
      {id: 1, name: 'общая' },
      {id: 2, name: 'Размешение' },
      {id: 3, name: 'Перегрузка' },
      {id: 4, name: 'Обработка' },
      {id: 5, name: 'Обезвреживание' },
    ],
    capacity_rest: [
      {id: 1, name: 'общая' },
      {id: 2, name: 'на 1 год' },
      {id: 3, name: 'на 2 года' },
      {id: 4, name: 'на 3 года' },
      {id: 5, name: 'на 4 года' },
      {id: 6, name: 'на 5 лет' },
      {id: 7, name: 'крупных объектов' },
      {id: 8, name: 'малых объектов' },
    ],
    mileage: [
      {id: 1, name: 'дневной' },
      {id: 2, name: 'месячный' },
      {id: 3, name: 'годовой' },
    ],
    removal_cost: [
      {id: 1, name: 'дневная' },
      {id: 2, name: 'месячная' },
      {id: 3, name: 'годовая' },
    ],
    transfer_cost: [
      {id: 1, name: 'дневная' },
      {id: 2, name: 'месячная' },
      {id: 3, name: 'годовая' },
    ],
    transportation_cost: [
      {id: 1, name: 'дневная' },
      {id: 2, name: 'месячная' },
      {id: 3, name: 'годовая' },
    ],
    processing_cost: [
      {id: 1, name: 'дневная' },
      {id: 2, name: 'месячная' },
      {id: 3, name: 'годовая' },
    ],
    total_cost: [
      {id: 1, name: 'дневная' },
      {id: 2, name: 'месячная' },
      {id: 3, name: 'годовая' },
    ]
  }*/
}



// WEBPACK FOOTER //
// ./src/store/analytics/defaults.js